"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Create initial snapshots
 * @param maxSize max size of all snapshots
 */
function createSnapshots(maxSize) {
    return {
        snapshots: [],
        totalSize: 0,
        currentIndex: -1,
        maxSize: maxSize,
    };
}
exports.default = createSnapshots;
//# sourceMappingURL=createSnapshots.js.map